
export function setAccountingToken(state, data) {
  state.accountingToken = data
}
export function setAccountingUrl(state, data) {
    state.accountingUrl = data
}

export function setCompanies(state, data) {
    state.companies = data
}
export function setSignature(state, data) {
    state.signature = data
}






